import { getAppLocale } from './languages';

export const dateFormatter = (
    value,
    locale = 'it-IT',
    { day, month, year, timestamp } = {
        day: 2,
        month: 2,
        year: 2,
        timestamp: false,
    }
) => {
    const formatter = new Intl.DateTimeFormat(locale, {
        day: `${day}-digit`,
        month: `${month}-digit`,
        year: `${year}-digit`,
    });

    const date = timestamp ? value * 1000 : value;

    return formatter.format(new Date(date));
};

export const formatNumberToLocale = (numInput, options) => {
    if (!numInput) {
        return 0;
    }

    return numInput.toLocaleString(getAppLocale(), options);
};
